import { ACTIONS } from "../../common/constants";

export const loadingAction = (bool) => {
  return bool
    ? {
        type: "SHOW_LOADER",
        data: bool,
      }
    : {
        type: "HIDE_LOADER",
        data: bool,
      };
};

export const notificationFail = (error, message) => {
  return {
    type: ACTIONS.GET_NOTIFICATION,
    data: { type: "ERROR", info: error.message, infoMessage: message },
  };
};

export const notificationSuccess = (message) => {
  return {
    type: ACTIONS.GET_NOTIFICATION,
    data: { type: "SUCCESS", code: 200, info: message, infoMessage: message },
  };
};

export const clearNotification = () => {
  return { type: ACTIONS.CLEAR_NOTIFICATION, data: null };
};

export const setScreenSize = (data) => {
  return { type: ACTIONS.SET_SCREEN_SIZE, data };
};

export const setEarningsDataAction = (data) => {
  return { type: ACTIONS.SET_EARNINGS_DATA, data };
};

export const setActiveInactiveDataAction = (data) => {
  return { type: ACTIONS.SET_ACTIVE_INACTIVE_DATA, data };
};

export const setCommisionsDataAction = (data) => {
  return { type: ACTIONS.SET_COMMISIONS_DATA, data };
};

export const lcoIdDataAction = (data) => {
  return { type: ACTIONS.SET_LCO_ID_DATA, data };
};

export const winbackDataAction = (data) => {
  return { type: ACTIONS.SET_WINBACK_UPGRADE_DATA, data };
};

export const setTicketTrackerDataAction = (data) => {
  return { type: ACTIONS.SET_TICKET_TRACKER_DATA, data };
};

export const setContactInfoAction = (data) => {
  return { type: ACTIONS.SET_CONTACT_INFO_DATA, data };
};

export const setUserDetailsAction = (data) => {
  return { type: ACTIONS.SET_USER_DATA, data };
};

export const setForbiddenAction = (data) => {
  return { type: ACTIONS.SET_FORBIDDEN, data };
};

export const setCartItemCountAction = (data) => {
  return { type: ACTIONS.SET_CART_ITEM_COUNT, data };
};

export const setStatementDataAction = (data) => {
  return { type: ACTIONS.SET_STATEMENT_DATA, data };
};

export const setProductListDataAction = (data) => {
  return { type: ACTIONS.SET_PRODUCT_LIST_DATA, data };
};

export const setCommonConfigDataAction = (data) => {
  return { type: ACTIONS.SET_COMMON_CONFIG_DATA, data };
};

export const setCaptureImage = (data) => {
  return { type: ACTIONS.SET_CAPTURE_IMAGE, data };
};

export const addInsurance = (data) => {
  return { type: ACTIONS.ADD_INSURANCE, data };
};

export const closeManageTeamPopUp = (data) => {
  return { type: ACTIONS.CLOSE_POP_UP, data };
};

export const deleteUser = (data) => {
  return { type: ACTIONS.DELETE_USER, data };
};

export const addMembers = (data) => {
  return { type: ACTIONS.ADD_MEMBERS, data };
};

export const editUser = (data) => {
  return { type: ACTIONS.EDIT_USER, data };
};

export const setActiveTabData = (data) => {
  return { type: ACTIONS.MANAGE_TEAM_ACTIVE_TAB, data };
};

export const setCdtFiltersData = (data) => {
  return { type: ACTIONS.SET_CDT_FILTERS, data };
};

export const viewQueries = (data) => {
  return { type: ACTIONS.VIEW_QUERIES, data };
};

export const raiseQuery = (data) => {
  return { type: ACTIONS.RAISE_QUERY, data };
};

export const viewInsuranceBenefits = (data) => {
  return { type: ACTIONS.VIEW_INSURANCE_BENEFITS, data };
};

export const setScmCircle = (data) => {
  return { type: ACTIONS.SET_CIRCLE, data };
};

export const setScmCircleOptions = (data) => {
  return { type: ACTIONS.SET_CIRCLE_OPTIONS, data };
};

export const setScmCart = (data) => {
  return { type: ACTIONS.SET_SCM_CART, data };
};

export const setScmCatalogFilters = (data) => {
  return { type: ACTIONS.SET_SCM_CATALOG_FILTERS, data };
};
